import React from 'react';
import { ITableDataSource } from 'models/table';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Link as LinkMui, Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import { Chips } from 'components/atoms/Chips';
import { emptyFieldHolder } from 'components/molecules/CardList';
import { ERouteLinks } from 'models/route';
import { licencePrintStatusVariant } from 'pages/LicencesPage/helpers';

interface IBatchPrintoutTableCard {
  data: ITableDataSource;
}

export const BatchPrintoutTableCard = ({ data }: IBatchPrintoutTableCard) => {
  const { t } = useTranslations();

  return (
    <Grid
      container
      sx={{
        border: `1px solid ${colors.gray200}`,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        backgroundColor: colors.gray100,
      }}
    >
      <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2, pt: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licences.printoutId.label')}
        </Typography>
        <Typography variant="body2">{data.printoutId}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2, pt: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licences.licenceNumber.label')}
        </Typography>
        <LinkMui
          href={ERouteLinks.DetailLicence.replace(
            ':licenceId',
            data.licenceUniqueId as string,
          )}
          underline="none"
          target="_blank"
          rel="noopener noreferrer"
        >
          {data.licenceNumber}
        </LinkMui>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2, pt: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licences.licenceOwnerName.label')}
        </Typography>
        <LinkMui
          href={`${ERouteLinks.ViewLegalEntity.replace(
            ':id',
            data.licenceOwnerUniqueId as string,
          )}?type=${data.licenceOwnerType}`}
          underline="none"
          target="_blank"
          rel="noopener noreferrer"
        >
          {data.licenceOwner}
        </LinkMui>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2, pt: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licences.licenceAuthority.label')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.licenceAuthority)}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2, pt: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licences.status.label')}
        </Typography>
        <Chips text={data.status} variant={licencePrintStatusVariant(data.statusUniqueId)} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2, pt: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licences.createDate.label')}
        </Typography>
        <Typography variant="body2">{data.createdDate}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2, pt: 2, pb: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licences.printDate.label')}
        </Typography>
        <Typography variant="body2">{data.printDate}</Typography>
      </Grid>
    </Grid>
  );
};
